import React from "react"
import ReactDOM from "react-dom"
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"
import * as htmlHelper from "../../helpers/html"
import Modal from "./modal"
import MapsPeopleMap from "../../styleguide/js/components/maps-people-map"
import Badge from "../badge/badge"
import ShopButton from "../shop-button/shop-button"
import ClassicModal from "./classicModal"
import MerchantContactUsModalContent from "./merchant-contact-us-modal-content"
import "../form-elements/_form-elements.scss"
import * as moment from "moment"

export default function createModalModule(elem) {
  elem.config = elem.dataset.config && JSON.parse(elem.dataset.config)
  elem.contentId = elem.dataset.contentId || document.body.dataset.currentpage
  elem.locale = elem.dataset.locale || document.body.dataset.language

  init()

  function init() {
    addEventListeners()
  }

  function addEventListeners() {
    Emitter.on("*", handleEvent)
  }

  function handleEvent(event) {
    const { type } = event
    switch (type) {
      case emits.REQUEST_ERROR_MODAL_OPEN:
        handleErrorModalOpen(event)
        break
      case emits.REQUEST_MAP_MODAL_OPEN:
        handleMapModalOpen(event)
        break
      case emits.REQUEST_CONTENT_MODAL_OPEN:
        handleContentModalOpen(event)
        break
      case emits.REQUEST_QA_MODAL_OPEN:
        handleQAModelOpen(event)
        break
      case emits.REQUEST_MERCHANT_CONTACT_MODAL:
        mountMerchantContactModal(event)
        break
      // case emits.REQUEST_ITINERARY_SIGNUP_MODAL:
      //   mountItinerarySignupModal(event)
      //   break
      default:
      // ignore
    }
  }

  function handleErrorModalOpen(event) {
    let message = ""
    try {
      const errorObj = JSON.parse(event.message)
      message = errorObj.error.modelErrorMessage
    } catch {
      message = event.message
    }
    mountErrorModal(message)
  }

  function mountErrorModal(message) {
    let modalError = "Der er sket en fejl"
    if (document.body.dataset.modalError) {
      modalError = document.body.dataset.modalError
    }
    ReactDOM.unmountComponentAtNode(elem)
    ReactDOM.render(
      <Modal
        isOpen={true}
        noScrollToTop="true"
        modifier="modal--fixed"
        overlayModifier="ReactModal__Overlay--fixed"
        bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
      >
        <div className="modal__content">
          <div className="rich-text">
            <h2>{modalError}</h2>
            <p>{String(message)}</p>
          </div>
        </div>
      </Modal>,
      elem,
    )
  }

  function handleMapModalOpen(event) {
    try {
      mountMapModal(event.message)
    } catch {
      console.log("handleMapModalOpen - failure")
    }
  }

  function mountMapModal(content) {
    ReactDOM.unmountComponentAtNode(elem)
    if (!content.mapAndTextBool && (content.modalImage || !window.google || !window.mapsindoors)) {
      if (content.modalImage && content.modalImageMobile) {
        ReactDOM.render(
          <Modal
            isOpen={true}
            noScrollToTop="true"
            modifier="modal--wide modal--fixed"
            overlayModifier="ReactModal__Overlay--fixed"
            bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
          >
            <div className="modal__bg">
              <picture>
                <source srcSet={content.modalImageMobile.imageSrc} media="(max-width: 767px)" />
                <source srcSet={content.modalImage.imageSrc} media="(min-width: 767px)" />
                <img src={content.modalImageMobile.imageSrc} alt={content.modalImageMobile.imageAlt} />
              </picture>
            </div>
          </Modal>,
          elem,
        )
      }
    } else {
      ReactDOM.render(
        <Modal
          isOpen={true}
          modifier="shop-modal pickup-modal modal--xlarge modal--fixed"
          overlayModifier="ReactModal__Overlay--fixed"
          bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
        >
          <div className="pickup-point">
            <div className="pickup-point__image">
              {content.modalImage && content.modalImageMobile ? (
                <picture>
                  <source srcSet={content.modalImageMobile.imageSrc} media="(max-width: 767px)" />
                  <source srcSet={content.modalImage.imageSrc} media="(min-width: 767px)" />
                  <img src={content.modalImageMobile.imageSrc} alt={content.modalImageMobile.imageAlt} />
                </picture>
              ) : (
                <div className="indoors-map js--maps-people-map" data-id="poi">
                  <div className="indoors-map__inner js--map"></div>
                </div>
              )}
            </div>
            <div className="pickup-point__content">
              <h2 className="pickup-point__headline">{content.Name}</h2>
              <p className="pickup-point__body">{content.Location}</p>
              <p className="trumpet">{content.openingHoursLabel}</p>
              <div className="opening-hours">{/* {content.openingHours} */}</div>
            </div>
          </div>
        </Modal>,
        elem,
      )
      new MapsPeopleMap({ el: document.querySelector(".js--maps-people-map") })
      document.getElementsByClassName("opening-hours")[document.getElementsByClassName("opening-hours").length - 1].innerHTML = content.openingHours
    }
  }

  function handleContentModalOpen(event) {
    mountContentModal(event.modalJson)
  }

  function mountContentModal(content) {
    ReactDOM.unmountComponentAtNode(elem)
    if (content.usePortalStyling) {
      ReactDOM.render(<ClassicModal isOpen={true} content={content} elem={elem}></ClassicModal>, elem)
    } else
      ReactDOM.render(
        <Modal
          isOpen={true}
          noScrollToTop="true"
          modifier="modal--fixed"
          overlayModifier="ReactModal__Overlay--fixed"
          bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
        >
          {content.image && content.image.imageSrc !== "/" ? (
            <div className="modal__bg">
              <picture>
                <source srcSet={content.image.imageSrc} media="(max-width: 767px)" />
                <source srcSet={content.image.imageSrc} media="(min-width: 767px)" />
                <img src={content.image.imageSrc} alt={content.image.imageAlt} />
              </picture>
              {content.badge && content.badge.content && (
                <Badge {...content.badge.theme} modifier={content.badge.theme.themeClass} content={content.badge.content} />
              )}
            </div>
          ) : null}
          <div className="modal__content">
            <div className="rich-text">{htmlHelper.htmlStringToReactElement(content.richText)}</div>

            <div className="modal__buttons">
              {content.button && content.button.showCta && <ShopButton text={content.button.link.linkText} link={content.button.link.linkUrl} />}
            </div>
          </div>
        </Modal>,
        elem,
      )
  }

  function renderSubQuestions(questionsJson, answersDict) {
    if (questionsJson && questionsJson.length > 0) {
      return questionsJson.map((question) =>
        answersDict[question?.questionNumber]?.answerText ? (
          <ul key={question?.questionNumber}>
            <li>
              {question?.questionText}
              <br />
              <p
                style={{ fontWeight: "bold" }}
                dangerouslySetInnerHTML={{ __html: urlify(ConvertYorNAnswerToWord(answersDict[question?.questionNumber]?.answerText)) }}
              ></p>
              {renderSubQuestions(question?.subQuestions, answersDict)}
            </li>
          </ul>
        ) : (
          ""
        ),
      )
    }
  }

  function handleQAModelOpen(event) {
    try {
      mountQAModal(event)
    } catch {
      console.log("handleQAModalOpen - failure")
    }
  }

  function mountQAModal(event) {
    const parentQuestion = event.modalQuestionsJson
    const subQuestionsJson = event.modalQuestionsJson?.subQuestions
    const answersDict = event.modalAnswers
    const parentAnswer = answersDict[parentQuestion?.questionNumber]?.answerText
    const parentAsnwerDate = moment(answersDict[parentQuestion?.questionNumber]?.datePublished)
    const lang = event.language
    const dateLabel = event.dateLabel
    ReactDOM.unmountComponentAtNode(elem)
    ReactDOM.render(
      <Modal
        isOpen={true}
        noScrollToTop="true"
        modifier="modal--fixed"
        overlayModifier="ReactModal__Overlay--fixed"
        bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
      >
        <div className="modal__content">
          <ul className="qa-modal">
            <li>
              {parentQuestion?.questionText}
              <br />
              <p style={{ fontWeight: "bold" }} dangerouslySetInnerHTML={{ __html: urlify(ConvertYorNAnswerToWord(parentAnswer)) }}></p>
              <ul>
                {subQuestionsJson.map((question) =>
                  answersDict[question?.questionNumber]?.answerText ? (
                    <li key={question?.questionNumber}>
                      {question?.questionText}
                      <br />
                      <p
                        style={{ fontWeight: "bold" }}
                        dangerouslySetInnerHTML={{
                          __html: urlify(ConvertYorNAnswerToWord(answersDict[question?.questionNumber]?.answerText)),
                        }}
                      ></p>
                      {renderSubQuestions(question?.subQuestions, answersDict)}
                    </li>
                  ) : (
                    ""
                  ),
                )}
              </ul>
            </li>
          </ul>
        </div>
        <p className="date-label">{parentAsnwerDate.locale(lang).format("[" + dateLabel + "] Do MMMM yyyy")}</p>
      </Modal>,
      elem,
    )
  }

  function mountMerchantContactModal(event) {
    ReactDOM.unmountComponentAtNode(elem)
    ReactDOM.render(<MerchantContactUsModalContent {...event.modalJson} />, elem)
  }

  function ConvertYorNAnswerToWord(answer) {
    if (answer === "Y") {
      return "Yes"
    } else if (answer === "N") {
      return "No"
    }
    return answer
  }

  function urlify(text) {
    var urlRegex =
      /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gim
    return text.replace(urlRegex, function (url) {
      if (url.substring(0, 7) === "http://" || url.substring(0, 8) === "https://") {
        return '<a href="' + url + '">' + url + "</a>"
      }
      url = "https://" + url
      return '<a href="' + url + '">' + url + "</a>"
    })
  }

  // Optionally return public API
  return { init }
}
